<template>
  <div id="app" class="app-wrapper app-root">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
    <!-- Disable add-account modal globally to stop accidental create-account prompts -->
    <add-account-modal v-if="false" />
    <woot-snackbar-box />
    <network-notification />
    <inbox-notification />
    <balance-notification />

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AddAccountModal from '../dashboard/components/layout/sidebarComponents/AddAccountModal';
import WootSnackbarBox from './components/SnackbarContainer';
import NetworkNotification from './components/NetworkNotification';
import InboxNotification from './components/InboxNotification';
import BalanceNotification from './components/BalanceNotification';
import { accountIdFromPathname } from './helper/URLHelper';

export default {
  name: 'App',

  components: {
    WootSnackbarBox,
    AddAccountModal,
    NetworkNotification,
    InboxNotification,
    BalanceNotification,
  },

  data() {
    return {
      showAddAccountModal: false,
    };
  },

  computed: {
    ...mapGetters({
      getAccount: 'accounts/getAccount',
      currentUser: 'getCurrentUser',
    }),
    hasAccounts() {
      return (
        this.currentUser &&
        this.currentUser.accounts &&
        this.currentUser.accounts.length !== 0
      );
    },
  },

  watch: {
    // currentUser() {
    //   if (!this.hasAccounts) {
    //     this.showAddAccountModal = true;
    //   }
    // },
  },
  mounted() {
    const { pathname } = window.location;
    const accountId = accountIdFromPathname(pathname);
    // Boot hydration: seed user from cookies immediately to avoid empty state
    // modals and 404s before async validity checks complete.
    this.$store.dispatch('hydrateUserFromCookies');
    this.setUser(accountId);
    this.setLocale(window.chatwootConfig.selectedLocale);
    this.initializeAccount();
  },

  methods: {
    async setUser(id) {
      await this.$store.dispatch('setUserInfo',id);
      await this.$store.dispatch('setUser');
    },

    setLocale(locale) {
      this.$root.$i18n.locale = locale;
    },

    async initializeAccount() {
      const { pathname } = window.location;
      const accountId = accountIdFromPathname(pathname);

      if (accountId) {
        await this.$store.dispatch('accounts/get');
        const { locale } = this.getAccount(accountId);
        this.setLocale(locale);
      }
    },
  },
};
</script>

<style lang="scss">
@import './assets/scss/app';
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
